module.exports = __webpack_public_path__ + "static/media/1_A1_18.0fb62076.png";